import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=30058009&scoped=true"
import script from "./configuration.vue?vue&type=script&lang=ts"
export * from "./configuration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30058009",
  null
  
)

export default component.exports